<template>
    <div class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">
          {{ route.params.id ? 'Editar Operador de Pagamento' : 'Novo Operador de Pagamento' }}
        </h4>
        <button class="btn btn-secondary btn-sm me-3" @click="voltar">Voltar</button>
      </div>
  
      <BaseForm :isFormValid="isFormValid" :isSubmitting="isSubmitting" @submit="salvarOperador" @cancel="voltar">
        <!-- Dados do Operador de Pagamento -->
        <FormSection title="Informações do Operador">
          <InputField
            v-model="operador.operador"
            label="Nome do Operador <span class='required'>*</span>"
            id="operador"
            placeholder="Digite o nome do operador"
            required
            :class="{ 'error-input': errors.operador }"
            width="400px"
          />
  
          <div class="form-group">
            <label for="ativo">Status <span class="required">*</span></label>
            <div class="form-switch">
              <input
                type="checkbox"
                id="ativo"
                v-model="operador.ativo"
                class="form-check-input"
              />
              <label for="ativo" class="form-check-label">
                {{ operador.ativo ? "Ativo" : "Inativo" }}
              </label>
            </div>
          </div>
        </FormSection>
      </BaseForm>
    </div>
  </template>
  
  <script>
  import { reactive, ref, computed, onMounted } from "vue";
  import { useRoute, useRouter } from "vue-router";
  import InputField from "@/components/Layout/InputField.vue";
  import FormSection from "@/components/Layout/FormSection.vue";
  import BaseForm from "@/components/Layout/BaseForm.vue";
  import axios from "@/services/axios";
  
  export default {
    components: { InputField, FormSection, BaseForm },
    setup() {
      const route = useRoute();
      const router = useRouter();
  
      const operador = reactive({
        id: null,
        operador: "",
        ativo: true, // Valor padrão
      });
  
      const errors = reactive({});
      const formTouched = ref(false);
      const isSubmitting = ref(false);
  
      const validateForm = () => {
        errors.operador = operador.operador ? "" : "O nome do operador é obrigatório.";
      };
  
      const isFormValid = computed(() => {
        return operador.operador.trim() !== "" && !Object.values(errors).some((error) => error);
      });
  
      const novoOperador = () => {
        formTouched.value = false;
        isSubmitting.value = false;
        Object.assign(operador, {
          operador: "",
          ativo: true,
        });
        for (const key in errors) {
          if (Object.hasOwn(errors, key)) errors[key] = "";
        }
      };
  
      const salvarOperador = async () => {
        if (isSubmitting.value) return;
  
        validateForm();
  
        if (!isFormValid.value) {
          console.error("O formulário contém erros:", errors);
          return;
        }
  
        isSubmitting.value = true;
        try {
          const method = operador.id ? "put" : "post";
          const url = operador.id
            ? `/financeiro/parametros/operadores/${operador.id}`
            : "/financeiro/parametros/operadores";
  
          await axios[method](url, {
            operador: operador.operador,
            ativo: operador.ativo,
          });
  
          router.push("/financeiro/parametros/operadores");
        } catch (error) {
          console.error("Erro ao salvar operador:", error);
        } finally {
          isSubmitting.value = false;
        }
      };
  
      const voltar = () => {
        router.push("/financeiro/parametros/operadores");
      };
  
      onMounted(async () => {
        const operadorId = route.params.id;
  
        if (operadorId) {
          try {
            const response = await axios.get(`/financeiro/parametros/operadores/${operadorId}`);
            Object.assign(operador, response.data);
          } catch (error) {
            console.error("Erro ao carregar operador:", error);
          }
        } else {
          novoOperador();
        }
      });
  
      return {
        operador,
        errors,
        isFormValid,
        formTouched,
        isSubmitting,
        salvarOperador,
        voltar,
        route,
      };
    },
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  
  .error-input {
    border-color: #dc3545;
  }
  
  .error-message {
    color: #dc3545;
    font-size: 0.875rem;
  }
  
  .form-switch {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  </style>
  